import React, { useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import KapalService from '../../../../services/kapal/KapalService'
// import { AsyncPaginate } from 'react-select-async-paginate'
import { FaEdit, FaEye, FaPlus, FaSearch, FaTrash } from 'react-icons/fa'
import ModalInspeksiChecklistHasil from './ModalInspeksiChecklistHasil'
import DataTable from 'react-data-table-component'
import ModalAddEditEvaluasiTeknis from './ModalAddEditEvaluasiTeknis'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalReviuRekom = ({ showReviuRekom, handleCloseReviuRekom, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {

    let kapalService = useMemo(() => new KapalService(), [])

    const columnsEvaluasi = [
        {
            name: 'Nama',
            cell: row => row['nmEvaluator']
        },
        {
            name: 'Catatan Tim Teknis',
            cell: row => row['catatanEvaluator']
        },
        {
            name: 'Tanggal Evaluasi',
            cell: row => row['tglEvaluasi']
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Lihat </Tooltip>}>
                            <Button size="sm" variant="info" onClick={() => handleClickViewEvaluasi(row)}>
                                <FaEye /> Lihat
                            </Button>
                        </OverlayTrigger>{' '}
                    </div>
                    {
                        dataPpmKapal.kodeStatus === '025' &&
                        <>
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Ubah </Tooltip>}>
                                    <Button size="sm" variant="warning" onClick={() => handleClickEditEvaluasi(row)}>
                                        <FaEdit /> Ubah
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                            <div className="col-12 mb-1">
                                <OverlayTrigger placement="bottom" overlay={
                                    <Tooltip >Hapus</Tooltip>}>
                                    <Button size="sm" variant="danger" onClick={() => handleClickDeleteEvaluasi(row)}>
                                        <FaTrash /> Hapus
                                    </Button>
                                </OverlayTrigger>{' '}
                            </div>
                        </>
                    }
                </div>
            )
        }
    ]
    const [listEvaluasi, setListEvaluasi] = useState(null)
    const [dataEvaluasi, setDataEvaluasi] = useState(null)
    const [loading, setLoading] = useState(false)
    const [isUnder5GT, setIsUnder5GT] = useState(null)
    const [isEditEvaluasi, setIsEditEvaluasi] = useState(null)
    const [idInspeksi, setIdInspeksi] = useState(null)

    useEffect(() => {
        if (!dataPpmKapal) return
        const fetchAllData = async () => {
            setLoading(true)
            try {
                const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal)
                if (resDataInspeksi) {
                    setIdInspeksi(resDataInspeksi.data.idInspeksi)
                    const resEvaluasi = await kapalService.listEvaluasiTeknisByIdInspeksi(resDataInspeksi.data.idInspeksi)
                    setListEvaluasi(resEvaluasi.data.data)

                    setIsUnder5GT(dataPpmKapal.ukuranKapal <= 5 ? 'Y' : 'T')
                }
            } catch (error) {

            }
            setLoading(false)
        }
        fetchAllData()
    }, [kapalService, dataPpmKapal])

    // const [valueApproveOpt, setValueApproveOpt] = useState(null)
    // const onChangeApprove = e => {
    //     setValueApproveOpt(e)
    // }

    // async function loadOptionApprove(search, loadedOption, { page = 1 }) {
    //     const response = await kapalService.listKesimpulan(8)
    //     return {
    //         options: response.data,
    //     }
    // }

    const [showHasilInspeksi, setShowHasilInspeksi] = useState(false)
    const handleCloseHasilInspeksi = () => setShowHasilInspeksi()
    const ViewHasilInspeksi = () => {
        setShowHasilInspeksi(true)
    }

    const [showEvaluasiTeknis, setShowEvaluasiTeknis] = useState(false)
    const handleCloseEvaluasiTeknis = () => setShowEvaluasiTeknis(false)

    const handleClickAddEvaluasi = () => {
        setIsEditEvaluasi(true)
        setShowEvaluasiTeknis(true)
    }
    const handleClickEditEvaluasi = (row) => {
        setIsEditEvaluasi(true)
        setDataEvaluasi(row)
        setShowEvaluasiTeknis(true)
    }
    const handleClickViewEvaluasi = (row) => {
        setIsEditEvaluasi(false)
        setDataEvaluasi(row)
        setShowEvaluasiTeknis(true)
    }
    const handleClickDeleteEvaluasi = (row) => {
        setListEvaluasi(prevList => {
            // console.log("Data sebelumnya:", prevList)
            const filtered = prevList.filter(item => !(item.nomorAjuKapal === row.nomorAjuKapal && item.nipEvaluator === row.nipEvaluator)).map((item, idx) => ({ ...item, nomorAjuKapal: row.nomorAjuKapal }))
            // console.log("Data sesudah hapus:", filtered)
            return filtered
        })
    }

    const [showConfirmSimpan, setShowConfirmSimpan] = useState(false)
    const handleCloseConfirmSimpan = () => setShowConfirmSimpan(false)
    const handleClickConfirmSimpan = () => {
        setShowConfirmSimpan(true)
    }

    const [loadingSimpan, setLoadingSimpan] = useState(false)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleCloseSuccess = () => {
        setShowSimpanSuccess(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleCloseFailed = () => {
        setShowSimpanFailed(false)
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickSimpan = async () => {
        setLoadingSimpan(true)
        try {
            const resDeleteEvaluasi = await kapalService.deleteEvaluasiTeknisByAju(dataPpmKapal.nomorAjuKapal)

            if (resDeleteEvaluasi.data.kode === '200') {
                listEvaluasi.map(async (evt) => {
                    let newJson = {
                        ...evt,
                        idInspeksi: idInspeksi
                    }
                    await kapalService.saveEvaluasiTeknis(newJson)
                })

                let dataDispo = {
                    ...dataDisposisi,
                    noTugas: 'EVT-' + dataPpmKapal.nomorAjuKapal,
                    tglTugas: new Date()
                }
                await kapalService.savePenugasan(dataDispo)

                setShowConfirmSimpan(false)
                setShowSimpanSuccess(true)
            } else {
                setShowConfirmSimpan(false)
                setShowSimpanFailed(true)
            }
        } catch (error) {
            setShowConfirmSimpan(false)
            setShowSimpanFailed(true)
        }
        setLoadingSimpan(false)
    }

    const handleClickClose = () => {
        // setHasilEvpDok([])
        // setValueCatatan('')
        // setValueKesimpulanOpt(null)
        handleCloseReviuRekom()
    }

    return (
        <>
            <Modal
                show={showReviuRekom}
                onHide={handleCloseReviuRekom}
                size='xl'
                centered
                backdrop='static'
                scrollable
            >
                <Modal.Header closeButton>
                    <Modal.Title><h5>Evaluasi Tim Teknis</h5></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju Kapal</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="NIB" className="form-control-sm" value={dataPpmKapal.nomorAjuKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.namaKapal} disabled />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                        <div className='col-6'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Ukuran Kapal</Form.Label>
                                    <Col sm="2">
                                        <Form.Control type="text" placeholder="Nama Kapal" className="form-control-sm" value={dataPpmKapal.ukuranKapal} disabled />
                                    </Col>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">GT</Form.Label>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Hasil Inspeksi</Form.Label>
                                    <Col sm="8">
                                        <Button size='sm' variant='outline-info' onClick={() => ViewHasilInspeksi()}><FaSearch />{' '}Lihat Hasil Inspeksi</Button>
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <SummaryChecklist nomorAjuKapal={dataPpmKapal.nomorAjuKapal} isUnde5Gt={isUnder5GT} />
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib"><b>Evaluasi Tim Teknis</b></Form.Label>
                                    <Col sm="2">
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            {dataPpmKapal.kodeStatus === '025' && <Button type="button" variant="primary" size="sm" onClick={() => handleClickAddEvaluasi()}><FaPlus /> Tambah Evaluasi Tim Teknis</Button>}
                            <div className="table-responsive border-bottom my-2">
                                {(loading && <Spinner />)}
                                {
                                    listEvaluasi &&
                                    <DataTable
                                        customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                        columns={columnsEvaluasi}
                                        data={listEvaluasi}
                                        highlightOnHover
                                        pagination
                                        persistTableHead={true}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    {/* {
                        dataDisposisi !== null && dataDisposisi.idDisposisi === 8 &&
                        <div className='row'>
                            <div className='col-12'>
                                <Form>
                                    <Form.Group as={Row} className="form-group">
                                        <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Persetujuan</Form.Label>
                                        <Col sm="8">
                                            <AsyncPaginate
                                                loadOptions={loadOptionApprove}
                                                value={valueApproveOpt}
                                                getOptionValue={(option) => option.idKesimpulan}
                                                getOptionLabel={(option) => option.urKesimpulan}
                                                additional={{
                                                    page: 0,
                                                }}
                                                onChange={onChangeApprove}
                                                isDisabled={!isEdit}
                                            />
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    } */}
                </Modal.Body>
                <Modal.Footer>
                    {dataPpmKapal.kodeStatus === '025' && <Button variant="primary" size="sm" onClick={() => handleClickConfirmSimpan()}>Simpan Evaluasi Teknis</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            <ModalInspeksiChecklistHasil showHasilInspeksi={showHasilInspeksi} handleCloseHasilInspeksi={handleCloseHasilInspeksi} dataPpmKapal={dataPpmKapal} />
            <ModalAddEditEvaluasiTeknis showEvaluasiTeknis={showEvaluasiTeknis} handleCloseEvaluasiTeknis={handleCloseEvaluasiTeknis} dataPpmKapal={dataPpmKapal} dataEvaluasi={dataEvaluasi} setListEvaluasi={setListEvaluasi} isEdit={isEditEvaluasi} />
            {
                showConfirmSimpan &&
                <SweetAlert
                    title="Simpan Evaluasi Teknis?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSimpan ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSimpan}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSimpan}
                    reverseButtons
                >
                    {loadingSimpan && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSimpanSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Berhasil"
                    onConfirm={handleCloseSuccess}
                    btnSize="sm"
                />
            }
            {
                showSimpanFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Gagal"
                    onConfirm={handleCloseFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

const SummaryChecklist = ({ nomorAjuKapal, isUnde5Gt }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [dataSummary, setDataSummary] = useState(null)

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                let response
                if (isUnde5Gt === 'Y') {
                    response = await kapalService.getSummaryChecklistSA(nomorAjuKapal)
                } else {
                    response = await kapalService.getSummaryChecklist(nomorAjuKapal)
                }
                setDataSummary(response.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [kapalService, nomorAjuKapal, isUnde5Gt])

    return (
        <>
            {
                isUnde5Gt === 'Y' && dataSummary &&
                <div className='row'>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Total</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Checklist" className="form-control-sm" value={dataSummary.jumlahChecklist} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Sesuai</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Sesuai" className="form-control-sm" value={dataSummary.jumlahSesuai} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-3'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="6" className="control-label align-self-center mb-0" htmlFor="searchNib">Tidak Sesuai</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahTidakSesuai} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            }
            {
                isUnde5Gt === 'T' && dataSummary &&
                <div className='row'>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Total</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Checklist" className="form-control-sm" value={dataSummary.jumlahChecklist} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">OK</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Sesuai" className="form-control-sm" value={dataSummary.jumlahOk} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Minor</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahMinor} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Mayor</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahMayor} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Kritis</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahKritis} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className='col-2'>
                        <Form>
                            <Form.Group as={Row} className="form-group">
                                <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">NA</Form.Label>
                                <Col sm="6">
                                    <Form.Control type="text" placeholder="Jumlah Tidak Sesuai" className="form-control-sm" value={dataSummary.jumlahNa} disabled />
                                </Col>
                            </Form.Group>
                        </Form>
                    </div>
                </div>
            }
        </>
    )
}

export default ModalReviuRekom